import React, { useEffect, useRef } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import img0 from "../assets/img/screenshoot/0.png"
import tugas_spg from "../assets/img/mobile_apps/tugas_spg.svg"
import absen from "../assets/img/mobile_apps/absen.svg"
import absen_detail from "../assets/img/mobile_apps/absen_detail.svg"
import total_karyawan from "../assets/img/mobile_apps/total_karyawan.svg"
import total_lokasi from "../assets/img/mobile_apps/total_lokasi.svg"
import tugas_1 from "../assets/img/mobile_apps/tugas_1.svg"
import tugas_2 from "../assets/img/mobile_apps/tugas_2.svg"
import grafik from "../assets/img/mobile_apps/grafik.svg"
import survey from "../assets/img/mobile_apps/survey.svg"
import map from "../assets/img/mobile_apps/map.svg"

// Register ScrollTrigger plugin
gsap.registerPlugin(ScrollTrigger);

const MobileApp: React.FC = () => {
    const sectionRef = useRef<HTMLElement>(null);
    const iphoneRef = useRef<HTMLImageElement>(null);
    const widgetsRef = useRef<(HTMLElement | null)[]>([]);

    useEffect(() => {
        const iphone = iphoneRef.current;
        const widgets = widgetsRef.current.filter(Boolean) as HTMLElement[];
        const section = sectionRef.current;

        if (!iphone || !section) return;

        // Initial setup
        gsap.set(iphone, { y: 800 });
        gsap.set(widgets, { opacity: 0, scale: 0 });

        function iPhoneAnimation() {
            const tl = gsap.timeline({ defaults: { duration: 1 } });
            tl.to(iphone, { y: 0 })
                .to(iphone, { rotation: 0, scale: 0.9 })
                .to(iphone, { duration: 3, scale: 1 });
            return tl;
        }

        function widgetAnimation() {
            const tl = gsap.timeline();
            tl.to(widgets, { duration: 0, opacity: 1 });
            return tl;
        }

        const animations = [
            {
                selector: "#tugas-spg",
                duration: 3,
                scale: 0.9,
                x: 500,
                y: 50,
                ease: "power4.out"
            },
            {
                selector: "#absen",
                duration: 3,
                scale: 0.9,
                x: -500,
                y: -300,
                ease: "power2.out"
            },
            {
                selector: "#tugas_2",
                duration: 3,
                scale: 1.1,
                x: -400,
                y: 350,
                ease: "power4.out"
            },
            {
                selector: "#tugas_1",
                duration: 3,
                scale: 0.9,
                x: 530,
                y: -170,
                ease: "power4.out"
            },
            {
                selector: "#survey",
                duration: 3,
                scale: 1.1,
                x: -350,
                y: -100,
                ease: "power2.out"
            },
            {
                selector: "#total_lokasi",
                duration: 3,
                scale: 1.1,
                x: 400,
                y: -360,
                ease: "power4.out"
            },
            {
                selector: "#absen_detail",
                duration: 3,
                scale: 0.9,
                x: -630,
                y: 0,
                ease: "power2.out"
            },
            {
                selector: "#total_karyawan",
                duration: 3,
                scale: 1,
                x: -280,
                y: 100,
                ease: "power4.out"
            },
            {
                selector: "#grafik",
                duration: 3,
                scale: 1,
                x: 350,
                y: 250,
                ease: "power4.out"
            },
            {
                selector: "#map",
                duration: 3,
                scale: 0.9,
                x: 270,
                y: -50,
                ease: "power2.out"
            },
        ];

        const startTime = 2;
        const masterTimeline = gsap.timeline();
        masterTimeline.add(iPhoneAnimation()).add(widgetAnimation(), startTime);

        animations.forEach((animation, index) => {
            const { selector, duration, scale, x, y, ease } = animation;
            const element = document.querySelector(selector);
            if (element) {
                masterTimeline.add(
                gsap.to(element, { duration, scale, x, y, ease }),
                startTime + (index % 3) / 2
                );
            }
        });

        // Create ScrollTrigger exactly like the HTML example
        ScrollTrigger.create({
            animation: masterTimeline,
            trigger: section,
            scrub: 1,
            pin: true
        });

        // Cleanup
        return () => {
            ScrollTrigger.getAll().forEach((trigger: any) => trigger.kill());
        };
    }, []);

    const addWidgetRef = (el: HTMLElement | null, index: number) => {
        if (widgetsRef.current) {
            widgetsRef.current[index] = el;
        }
    };

    const sectionStyles: React.CSSProperties = {
        position: 'relative',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        width: '100vw',
        // background: '#0d0d0d'
    };

    const iphoneStyles: React.CSSProperties = {
        position: 'absolute',
        height: '560px'
    };

    const widgetStyles: React.CSSProperties = {
        position: 'absolute',
        zIndex: -1,
        transform: 'scale(0)'
    };

    return (
        <section ref={sectionRef} className="animation" style={sectionStyles}>
            <img 
                ref={iphoneRef}
                className="iphone" 
                src={img0}
                alt="" 
                style={iphoneStyles}
            />
        
            <img 
                ref={(el) => addWidgetRef(el, 0)}
                id="tugas-spg" 
                className="widgets" 
                src={tugas_spg}
                alt="" 
                style={widgetStyles}
            />
        
            <img 
                ref={(el) => addWidgetRef(el, 1)}
                id="absen" 
                className="widgets" 
                src={grafik}
                alt="" 
                style={widgetStyles}
            />
        
            <img 
                ref={(el) => addWidgetRef(el, 2)}
                id="tugas_2" 
                className="widgets" 
                src={tugas_2} 
                alt="" 
                style={widgetStyles}
            />
        
            <img 
                ref={(el) => addWidgetRef(el, 3)}
                id="tugas_1" 
                className="widgets" 
                src={tugas_1}
                alt="" 
                style={widgetStyles}
            />
        
            <img 
                ref={(el) => addWidgetRef(el, 4)}
                id="absen_detail" 
                className="widgets" 
                src={absen_detail} 
                alt="" 
                style={widgetStyles}
            />
        
            <img 
                ref={(el) => addWidgetRef(el, 5)}
                id="survey" 
                className="widgets" 
                src={survey}
                alt="" 
                style={widgetStyles}
            />
        
            <img 
                ref={(el) => addWidgetRef(el, 6)}
                id="total_lokasi" 
                className="widgets" 
                src={total_lokasi}
                alt="" 
                style={widgetStyles}
            />
        
            <img 
                ref={(el) => addWidgetRef(el, 7)}
                id="map" 
                className="widgets" 
                src={map} 
                alt="" 
                style={widgetStyles}
            />
        
            <img 
                ref={(el) => addWidgetRef(el, 8)}
                id="grafik" 
                className="widgets" 
                src={absen}
                alt="" 
                style={widgetStyles}
            />
        
            <img 
                ref={(el) => addWidgetRef(el, 9)}
                id="total_karyawan" 
                className="widgets" 
                src={total_karyawan}
                alt="" 
                style={widgetStyles}
            />
        </section>
    );
};

export default MobileApp;